import { create } from "@bufbuild/protobuf";
import { useMutation, UseMutationOptions } from "@connectrpc/connect-query";
import { useQueryClient } from "@tanstack/react-query";

import { GetSourceRequestSchema } from "@gx/ts-contracts/services/source/api/source_pb";
import { ListSourceSyncsRequestSchema } from "@gx/ts-contracts/services/source/api/source_sync_pb";
import { createSourceSync } from "@gx/ts-contracts/services/source/api/source_sync-SourceSyncService_connectquery";

import { createGetSourceQueryKey, createListSourcesInfiniteQueryKey } from "@/api/queries/sources";
import { createListSourceSyncsQueryKey } from "@/api/queries/syncs";

// ========== CREATE SYNC ==========

export const useCreateSyncMutation = (
  options?: UseMutationOptions<typeof createSourceSync.input, typeof createSourceSync.output>,
) => {
  const queryClient = useQueryClient();
  return useMutation<typeof createSourceSync.input, typeof createSourceSync.output>(
    createSourceSync,
    {
      ...options,
      onSuccess: (data, variables, onMutateResult, context) => {
        void queryClient.invalidateQueries({
          queryKey: createGetSourceQueryKey(
            create(GetSourceRequestSchema, { sourceId: variables.sourceId }),
          ),
        });
        void queryClient.invalidateQueries({
          queryKey: createListSourceSyncsQueryKey(
            create(ListSourceSyncsRequestSchema, { sourceId: variables.sourceId }),
          ),
        });
        void queryClient.invalidateQueries({
          queryKey: createListSourcesInfiniteQueryKey(),
        });
        if (options?.onSuccess) {
          options.onSuccess(data, variables, onMutateResult, context);
        }
      },
    },
  );
};
